/* USI filter sidebar: brand search box. Delegated so it keeps working after Empire re-renders the sidebar on each filter click. */
(function () {
  function isSearch(el) { return el && el.matches && el.matches('[data-usi-facet-search]'); }
  document.addEventListener('input', function (e) {
    if (!isSearch(e.target)) return;
    var q = e.target.value.trim().toLowerCase();
    var list = e.target.closest('ul');
    if (!list) return;
    list.querySelectorAll('li.collection-filters__filter-list-item').forEach(function (li) {
      var text = (li.textContent || '').toLowerCase();
      li.classList.toggle('usi-facet-hidden', q !== '' && text.indexOf(q) === -1);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && isSearch(e.target)) e.preventDefault();
  });
})();
/* USI filter sidebar: on desktop every group is always open, so headers report expanded and leave the tab order. */
(function () {
  var mq = window.matchMedia('(min-width: 860px)');
  function sync() {
    document.querySelectorAll('.productgrid--outer.layout--has-sidebar [data-filter-group-trigger]').forEach(function (b) {
      if (mq.matches) { b.setAttribute('aria-expanded', 'true'); b.setAttribute('tabindex', '-1'); b.setAttribute('data-usi-locked', ''); }
      else if (b.hasAttribute('data-usi-locked')) { b.removeAttribute('tabindex'); b.removeAttribute('data-usi-locked'); }
    });
  }
  function start() {
    sync();
    var outer = document.querySelector('[data-productgrid-outer]') || document.body;
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].type === 'childList') { sync(); return; } }
    }).observe(outer, { childList: true, subtree: true });
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
